"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReceivablesAccessTokenTransport = exports.ReceivablesAccessTokenCreateInput = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.ReceivablesAccessTokenCreateInput = typebox_1.Type.Object({
    receivableID: typebox_1.Type.String({ format: 'uuid' }),
});
exports.ReceivablesAccessTokenTransport = typebox_1.Type.Object({
    key: typebox_1.Type.String(),
    expires: typebox_1.Type.String(),
});
//# sourceMappingURL=SGRecivablesAccessToken.js.map